(ns hai.mini-apps.common
  "Shared helpers for mini-app views (edit, table)."
  (:require
   [hai.ui.icons :as icons]
   #?(:cljs [hai.ui.rf-sugar :refer [defeffect]])
   #?(:cljs [lambdaisland.glogi :as log])
   [hai.ui.tokens :as t]))

;; The browser extension injects a content script on every page, including this web-app.
;; It listens for this postMessage from our origin and asks the service
;; worker to refresh every open sidebar — so changing a mini-app here (toggling,
;; creating, deleting, or editing settings) updates the extension live, without
;; the user having to reload the page.
;; A no-op (unheard) when the extension isn't installed.
;; Add `[:browser-ext/notify-mini-apps-changed {:mini-app/uuids [uuid]
;;                                              :change :created/:updated/:deleted}]`
;; to the `:on-success-fx` of any mini-app mutation that changes the active set.
#?(:cljs
   (defeffect :browser-ext/notify-mini-apps-changed [{:mini-app/keys [uuids] :keys [change]}]
     (log/info ::notify-mini-apps-changed {:mini-app/uuids uuids :change change})
     (js/window.postMessage
       (clj->js {:humble_ext_event "mini-apps-changed"
                 :mini_app_uuids   uuids
                 :change           (some-> change name)})
       "*")))

(def icon icons/outlined-web)

(def tool->icon
  "Maps a `:mini-app/tool` (or `:connection/type`) keyword to its icon component."
  {:airtable  icons/airtable
   :notion    icons/notion
   :hubspot   icons/hubspot
   :jdbc      icons/database-generic
   :database  icons/database-generic
   :organizer icons/humble
   :notes     icons/sticky-note
   :tasks     icons/outlined-task_alt})

(def ->label :mini-app/title)

(defn ->icon
  [mini-app]
  (or (-> mini-app
          :mini-app/tool
          tool->icon)
      icon))

(defn ->tint
  [_]
  t/--colour-purple-30)
